import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Layout, Spin } from "antd";
import { ConnectedProps } from "react-redux";

import Navbar from "../../components/Navbar";
import { NavigationPath, isPathAccessible, roleAccess } from "../../utils";
import connector from "./Container";

const { Content } = Layout;

const PrivateNoSidebarRoute = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { user } = state;
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("userToken");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    actions.setLoggedUser();
  }, [actions]);

  useEffect(() => {
    if (!token || !user?.role) {
      setLoading(false);
      return;
    }

    const roleHasAccess = isPathAccessible(
      location.pathname,
      roleAccess[user.role]
    );

    if (!roleHasAccess) {
      if (window.history.length > 2) {
        navigate(-1);
      } else {
        navigate(NavigationPath.LOGIN_ROUTE);
      }
      return;
    }

    setLoading(false);
  }, [token, navigate, location, user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  return token ? (
    <Layout className="min-h-screen">
      <Navbar />

      <Layout>
        <Layout className="p-5">
          <Content className="m-0 min-h-72 bg-base-gray">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  ) : (
    <Navigate to={NavigationPath.LOGIN_ROUTE} />
  );
};

export default PrivateNoSidebarRoute;
